module.exports = __webpack_public_path__ + "img/acuenta.15d8183.png";